export const MAX_PHOTO_FILE_SIZE_MB = 50
export const MAX_PHOTO_FILE_SIZE_BYTES = MAX_PHOTO_FILE_SIZE_MB * 1024 * 1024

export function isValidPhotoFileSize(file: Pick<Blob, "size">): boolean {
  return file.size <= MAX_PHOTO_FILE_SIZE_BYTES
}
